import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

// Paste your config from Firebase Console → Project Settings → Your apps → SDK setup
const firebaseConfig = {
  apiKey: "AIzaSyAvJvGfxj1iUuy1P3FCzjozHgWEoQN1LUY",
  authDomain: "cardiumapp-77576.firebaseapp.com",
  projectId: "cardiumapp-77576",
  storageBucket: "cardiumapp-77576.firebasestorage.app",
  messagingSenderId: "630966660308",
  appId: "1:630966660308:web:7e8a6dfb02f762763f5f41"
};

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
